'use strict';

const { queryFirst, addClass, removeClass, queryAll } = require('../domUtil');

module.exports = () => {
    const categoryContent = queryAll('.sbs-wrapper');
    const hiddenClass = 'd-none';
    const option1 = queryFirst('.option-1');
    const selector = queryFirst('.category-select');

    addClass(categoryContent, hiddenClass);
    removeClass(option1, hiddenClass);

    if (selector) {
        selector.addEventListener('change', function () {
            addClass(categoryContent, hiddenClass);
            let currOption = this.options[this.selectedIndex].value;
            removeClass(queryFirst('.' + currOption), hiddenClass);
        });

        window.onload = function () {
            selector.options["1"].selected = true;
        };
    }
};